import MilestonesAdapter from './base';

export default class Milestone extends MilestonesAdapter {
  modelNamePlural = 'milestones';
}
